import { render } from "./themes-filter-category.vue?vue&type=template&id=b259235a&scoped=true"
import script from "./themes-filter-category.vue?vue&type=script&lang=js"
export * from "./themes-filter-category.vue?vue&type=script&lang=js"

import "./themes-filter-category.vue?vue&type=style&index=0&id=b259235a&scoped=true&lang=less"

import exportComponent from "C:\\Users\\bartelmus\\Desktop\\git\\spiel26-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b259235a"]])

export default __exports__